// extracted by mini-css-extract-plugin
module.exports = {"IconDelivery":"DeliveryFoodHeader_IconDelivery__1hLEZ"};